import styled from 'styled-components';

export const SingleValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
